import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";

const inp = "w-full h-11 bg-muted/60 border px-3 text-sm outline-none focus:border-primary";

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const forced = user?.must_change_password;
  const needCurrent = user?.has_password && user?.auth_method !== "google";
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) { toast.error("The new passwords don't match"); return; }
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated");
      await refresh();
      nav("/", { replace: true });
    } catch (ex) { toast.error(errMsg(ex)); }
  };
  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <form onSubmit={submit} className="w-full max-w-sm ax-panel p-6 ax-fade" data-testid="change-password-form">
        <h2 className="text-xl font-semibold">{forced ? "Set your own password" : user?.has_password ? "Change password" : "Create a password"}</h2>
        <p className="text-sm text-muted-foreground mt-1">{forced ? "You signed in with a temporary password. Type it in the first box, then choose a new one." : user?.auth_method === "google" ? "You're signed in with Google, so you can set a password directly. At least 10 characters, with letters and numbers." : "At least 10 characters, with letters and numbers."}</p>
        <div className="space-y-3 mt-5">
          {needCurrent && <input data-testid="cp-current" type="password" required placeholder={forced ? "Temporary password" : "Current password"} value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} className={inp} />}
          <input data-testid="cp-new" type="password" required placeholder="New password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} className={inp} />
          <input data-testid="cp-confirm" type="password" required placeholder="Confirm new password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className={inp} />
        </div>
        <button data-testid="cp-submit" type="submit" className="mt-4 w-full h-11 bg-primary text-primary-foreground text-sm">Save password</button>
      </form>
    </div>
  );
}
